const state = {
  current_category: null,
  current_advertise_contact_phone: null
};

const getters = {
  current_category(state) {
    return state.current_category
  }
};

const actions = {
  setAdvertiseContactPhone({commit}, phone) {
    commit('set_Advertise_contact_phone', phone)
  },
  current_category(context, category) {
    return context.commit("current_category", category);
  },
};

const mutations = {
  set_Advertise_contact_phone(state, phone) {
    state.current_advertise_contact_phone = phone
  },
  current_category(state, category) {
    state.current_category = category
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
